import React, { useState } from "react";
import BoxTypo from "../components/BoxTypo";
import { Box, Button, Slider, Stack } from "@mui/material";
import "../style/base.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { nl2br } from "../functions/nl2br";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import "../style/font-style.css";
import "../style/mui-override.css";
import { StaticImage } from "gatsby-plugin-image";

const QuestionCard = (props) => {
  const setIndexFunc =
    props.questionNumber == props.totalLength - 1
      ? () => {
        props.setHiddenResult((c) => false);
      }
      : () => {
        props.setIndex((c) => c + 1);
      };
  return (
    <Box className="w100 mw600 tac ma pr" height={"75vh"}>
      {props.type === "start" ? (
        <></>
      ) : (
        <Box>
          <BoxTypo
            fs={["18px", "22px"]}
            ls={["2px"]}
            lh={["200%"]}
            color="#4A4A4A"
          >
            Q{props.questionNumber}
          </BoxTypo>
          <Box>
            <Stack
              spacing={2}
              direction="row"
              sx={{ mb: 1 }}
              alignItems="center"
              justifyContent="center"
            >
              <Slider
                value={(props.questionNumber / props.totalLength) * 100}
                size="small"
                disabled={true}
                style={{
                  width: "40%",
                  height: "4px",
                  maxWidth: "300px",
                  color: "#DECFA8",
                }}
              />
            </Stack>
          </Box>
          <BoxTypo
            fs={["14px", "18px"]}
            lh={["200%"]}
            height="60px"
            mt={8}
            color="#4A4A4A"
          >
            {nl2br(props.question)}
          </BoxTypo>
        </Box>
      )}

      <Box>
        {props.type === "start" ? (
          <DiagnosisStart
            choices={props.choices}
            setIndex={setIndexFunc}
            label={props.label}
          />
        ) : props.type === "pullDown" ? (
          <PullDown
            choices={props.choices}
            setIndex={setIndexFunc}
            label={props.label}
          />
        ) : props.type === "buttonGroup" ? (
          <ButtonGroup
            className="w100"
            setIndex={setIndexFunc}
            choices={props.choices}
          />
        ) : (
          <RadioButtonGroup
            className="w100 "
            setIndex={setIndexFunc}
            choices={props.choices}
          />
        )}
      </Box>
      <Box className="pa b0" style={{ left: "10%" }} borderRadius={4}>
        <Button
          style={{ display: props.questionNumber <= 1 ? "none" : "block" }}
          onClick={() => {
            props.setIndex((c) => (c > 0 ? c - 1 : 0));
            props.setHiddenResult(true);
          }}
          value={false}
        >
          <Stack alignItems={"center"} justifyContent={"center"}>
            <ArrowBackIosOutlinedIcon style={{ color: "#DECFA8" }} />
            <BoxTypo fs={["12px"]} ls={["2px"]} lh={["200%"]} color="#DECFA8">
              Back
            </BoxTypo>
          </Stack>
        </Button>
      </Box>
      <Box className="pa b0" style={{ right: "10%" }}>
        <Button
          disabled={props.hiddenResult}
          style={{
            display:
              props.questionNumber < props.totalLength - 1 ? "none" : "block",
            boxShadow: "none",
            backgroundColor: props.hiddenResult ? "#F5EFE6" : "#DECFA8",
            height: "90px",
            width: "90px",
            borderRadius: "90px",
          }}
          variant="contained"
          onClick={() => { }}
          value={false}
        >
          <BoxTypo
            fs={["12px"]}
            ls={["2px"]}
            lh={["200%"]}
            color={props.hiddenResult ? "#CFCFCF" : "#fff"}
          >
            診断結果
          </BoxTypo>
        </Button>
      </Box>
    </Box>
  );
};

const ButtonGroup = (props) => {
  return (
    <Box className="w100 mt64">
      <Stack>
        {props.choices.map((c, i) => {
          return (
            <Button
              key={i}
              variant="outlined"
              className="w90 mw300 ma db mt16"
              onClick={props.setIndex}
              style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "none",
                color: "#4A4A4A",
              }}
            >
              <BoxTypo fs={["14px"]} ls={["2px"]} lh={["180%"]}>
                {c.text}
              </BoxTypo>
            </Button>
          );
        })}
      </Stack>
    </Box>
  );
};

const RadioButtonGroup = (props) => {
  return (
    <FormControl className="w80 ma mw600 tac" style={{ marginTop: "128px" }}>
      <RadioGroup
        row
        aria-label="gender"
        defaultValue={props.choices[0].text}
        name="radio-buttons-groups"
        className="ma tac w90 "
        style={{ justifyContent: "space-between" }}
      >
        {props.choices.map((c, i) => {
          return (
            <FormControlLabel
              key={i}
              value={c.text}
              onClick={props.setIndex}
              style={{ fontFamily: "serif" }}
              control={
                <Radio
                  size="large"
                  fontSize="30px"
                  fontFamily="serif"
                  fontWeight="500"
                  style={{
                    border: "none",
                    color: "#DECFA8",
                    fontFamily: "serif",
                    fontWeight: "500",
                  }}
                />
              }
              label={c.text}
              labelPlacement="bottom"
              className="cblk"
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

const PullDown = (props) => {
  const [value, setValue] = useState("選択してください");
  return (
    <Box className="w80 mw600 ma tac pr">
      <FormControl className="w100 mw300" style={{ marginTop: "30%" }}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          style={{
            color: "#000",
            backgroundColor: "#fff",
            border: "none",
            outline: "none",
            borderColor: "#fff",
          }}
          onChange={(e) => {
            setValue(e.target.value);
            props.setIndex((c) => c + 1);
          }}
        >
          {props.choices.map((c, i) => {
            return (
              <MenuItem value={c.text} key={i}>
                <BoxTypo key={i} fs={["12px"]} ls={["2px"]} lh={["100%"]}>
                  {c.text}
                </BoxTypo>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

const DiagnosisStart = (props) => {
  return (
    <Box className="w100  db ma tac">
      <Stack className="w100 tac ma" alignItem="space-between">
        <StaticImage
          src="../images/ForuGranola.png"
          alt="A dinosaur"
          className="w50 mw600 ma mt128"
        />
        <BoxTypo
          fs={["10px"]}
          ls={["4px"]}
          lh={["180%"]}
          color={"#000"}
          mt={"8px"}
        >
          2分間のグラノーラ診断
        </BoxTypo>
        <Box className="mt64">
          <Button
            variant="outlined"
            className="w80 mw300 ma tac"
            style={{
              color: "#fff",
              border: "solid 1.5px #DECFA8",
              backgroundColor: "#DECFA8",
            }}
            onClick={props.setIndex}
          >
            <BoxTypo fs={["14px"]} ls={["2px"]} lh={["100%"]}>
              診断を始める
            </BoxTypo>
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default QuestionCard;
